import formatGroupedValues from "../utils/formatGroupedValues";

export const CLIENT_CONTACTS_SORT_OPTIONS = [
  { value: "firstName", label: "First Name" },
  { value: "lastName", label: "Last Name" },
];

export const CLIENT_CONTACTS_DEFAULT_FILTERS = {
  selectedLocations: [],
  selectedRoles: [],
  sortBy: "firstName",
  sortDirection: "asc",
};

export function buildClientContactsFilterChips({
  selectedLocations = [],
  selectedRoles = [],
}) {
  const chips = [];
  if (selectedLocations.length > 0) {
    chips.push({
      id: "locations",
      key: "selectedLocations",
      fieldId: "contacts-locations",
      label: `Locations: ${formatGroupedValues(selectedLocations, (v) => v, 3)}`,
    });
  }
  if (selectedRoles.length > 0) {
    chips.push({
      id: "roles",
      key: "selectedRoles",
      fieldId: "contacts-roles",
      label: `Roles: ${formatGroupedValues(selectedRoles, (v) => v, 3)}`,
    });
  }
  return chips;
}
